import { render, staticRenderFns } from "./WelcomeTransition.vue?vue&type=template&id=df026cc8&scoped=true"
import script from "./WelcomeTransition.vue?vue&type=script&lang=js"
export * from "./WelcomeTransition.vue?vue&type=script&lang=js"
import style0 from "./WelcomeTransition.vue?vue&type=style&index=0&id=df026cc8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df026cc8",
  null
  
)

export default component.exports